import React, { useEffect, useState } from 'react';
import { coinApi } from '../../../../api/coin';
import CircleChart from '../../../../components/ui/CircleChart';
import { getGrowth } from '../../../../utils/values';

const PortfolioShare = ({ address, network, audience, className = '' }) => {
  const [data, setData] = useState([]);
  const [avgShare, setAvgShare] = useState('');
  const {
    data: nftData,
    isLoading,
    isFetching,
  } = coinApi.useGetNftSharePortfolioQuery({ address, network, audience });

  useEffect(() => {
    if (nftData?.buckets && !isLoading && !isFetching) {
      const total = nftData.buckets.reduce((sum, { value }) => sum + value, 0);
      if (total === 0) return;
      const newData = nftData.buckets.map((bucket, index) => {
        const labelMap = [
          '< 5%',
          '5% to < 25%',
          '25% to < 50%',
          '50% to < 75%',
          '75% to < 99%',
          '100%',
        ];
        const percent = total ? ((bucket.value * 100) / total).toFixed(2) : 0;
        return {
          label: labelMap[index],
          count: bucket.value,
          percent: +percent,
        };
      });

      const median = nftData?.median ? nftData.median.toFixed(2) : 0;
      setAvgShare(`${median}%`);
      setData(newData);
    } else {
      setData([]);
    }
  }, [nftData, isLoading, isFetching]);

  return (
    <div className={className || ''}>
      {data && data.length > 0 && (
        <CircleChart
          title="Share of Portfolio"
          highlightText="Median Share of Portfolio"
          highlightValue={avgShare}
          data={data}
          isLoading={isLoading || isFetching}
          landscape
          growth={
            nftData
              ? getGrowth(
                  nftData?.median,
                  nftData?.previous_values?.median,
                  `${(nftData?.previous_values?.median || 0).toFixed(2)}%`
                )
              : null
          }
        />
      )}
    </div>
  );
};

export default PortfolioShare;
